export default __webpack_public_path__ + "static/media/20.e34091ca.png";